// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
    border: 1px solid #ccc;
    border-radius: 5px;
    overflow: hidden;
  }
  
  .accordion-item {
    border-bottom: 1px solid #ccc;
  }
  
  .accordion-title {
    background-color: #f5f5f5;
    color: #333;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
  }

  .accordion-title.active {
    background-color: #ddd;
  }
  
  .accordion-content {
    padding: 10px;
    display: none;
  }
  .accordion-content.active {
    display: block; 
  }
  .accordion-title::before {
    content: '\\25BA'; /* Right-pointing triangle (▶) */
    display: inline-block;
    margin-right: 10px; /* Adjust spacing as needed */
    transition: transform 0.3s ease; /* Add transition for smooth animation */
  }
  
  .accordion-title.active::before {
    transform: rotate(90deg); /* Rotate the triangle when active */
  }
  `, "",{"version":3,"sources":["webpack://./src/css/AccordionBlock.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,gBAAgB,EAAE,gCAAgC;IAClD,qBAAqB;IACrB,kBAAkB,EAAE,6BAA6B;IACjD,+BAA+B,EAAE,wCAAwC;EAC3E;;EAEA;IACE,wBAAwB,EAAE,oCAAoC;EAChE","sourcesContent":[".accordion {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    overflow: hidden;\n  }\n  \n  .accordion-item {\n    border-bottom: 1px solid #ccc;\n  }\n  \n  .accordion-title {\n    background-color: #f5f5f5;\n    color: #333;\n    padding: 10px;\n    cursor: pointer;\n    font-weight: bold;\n  }\n\n  .accordion-title.active {\n    background-color: #ddd;\n  }\n  \n  .accordion-content {\n    padding: 10px;\n    display: none;\n  }\n  .accordion-content.active {\n    display: block; \n  }\n  .accordion-title::before {\n    content: '\\25BA'; /* Right-pointing triangle (▶) */\n    display: inline-block;\n    margin-right: 10px; /* Adjust spacing as needed */\n    transition: transform 0.3s ease; /* Add transition for smooth animation */\n  }\n  \n  .accordion-title.active::before {\n    transform: rotate(90deg); /* Rotate the triangle when active */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
